import { connect } from 'react-redux';
import DisclaimerDialog from './DisclaimerDialog';


const mapStateToProps = state => ({
    selectedFinancing: state.settings.selectedFinancing,
    taxEntity: state.tax.taxEntity,
    projectState: state.projectaddress.projectState,
    resiToggle: state.tax.resiToggle,
});

const combinedActions = {
};

export default connect(mapStateToProps, combinedActions)(DisclaimerDialog);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/DisclaimerDialog/index.js